import { useState } from "react";
import { Heading } from "style/components/Heading.styles";
import { ChangePasswordContainer } from "./ChangePassword.styles";
import { Button } from "components/Button/index";
import { ChangePasswordModal } from "./ChangePasswordModal";

export const ChangePassword = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <ChangePasswordContainer>
      <section>
        <div className="password-heading-container">
          <div className="password-heading-wrapper">
            <Heading>Password</Heading>
            <span>Set a unique password to protect your Surmount account</span>
          </div>
          <div className="password-button-wrapper">
            <Button variant="secondary" size="small" onClick={handleOpenModal}>
              Change Password
            </Button>
          </div>
        </div>
      </section>

      <ChangePasswordModal show={showModal} onHide={handleCloseModal} />
    </ChangePasswordContainer>
  );
};
